import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

export const useHasWireTransferDelegationFeature = (): boolean => {
  return useFeature(FEATURES.WIRE_TRANSFER_DELEGATION);
};
